const EMOJI_BASE_PATH = "/assets/media/emoji";

type EmojiData = {
    emoji: string;
    unicode: string; 
};

type EmojiDictionary = {[emojiName: string]: EmojiData};
export const EMOJI_DICTIONARY = {
    "grinning_face": {
        emoji: "😀",
        unicode: "u1f600"
    },
    "worried_face": {
        emoji: "😟",
        unicode: "u1f61f",
    },
    "crying_face": {
        emoji: "😢",
        unicode: "u1f622",
    },
    "loudly_crying_face": {
        emoji: "😭",
        unicode: "u1f62d",
    },
    "relieved_face": {
        emoji: "😌",
        unicode: "u1f60c",
    },
    "astonished_face": {
        emoji: "😲",
        unicode: "u1f632",
    },
    "winking_face": {
        emoji: "😉",
        unicode: "u1f609",
    },
    "face_blowing_a_kiss": {
        emoji: "😘",
        unicode: "u1f618",
    },
    "smiling_face_with_heart_eyes": {
        emoji: "😍",
        unicode: "u1f60d",
    },
    "face_with_tears_of_joy": {
        emoji: "😂",
        unicode: "u1f602",
    },
    "smiling_face_with_sunglasses": {
        emoji: "😎",
        unicode: "u1f60e",
    },
    "dizzy_face": {
        emoji: "😵",
        unicode: "u1f635",
    },
    "angry_face": {
        emoji: "😠",
        unicode: "u1f620",
    },
    "pouting_face": {
        emoji: "😡",
        unicode: "u1f621",
    },
    "face_with_rolling_eyes": {
        emoji: "🙄",
        unicode: "u1f644",
    },
    "smiling_face_with_smiling_eyes": {
        emoji: "😊",
        unicode: "u1f60a",
    },
    "face_with_stuck-out_tongue_and_tightly-closed_eyes": {
        emoji: "😝",
        unicode: "u1f61d",
    },
    "face_with_head-bandage": {
        emoji: "🤕",
        unicode: "u1f915",
    },
    "face_screaming_in_fear": {
        emoji: "😱",
        unicode: "u1f631",
    },
    "cold_face": {
        emoji: "🥶",
        unicode: "u1f976",
    },
    "nauseated_face": {
        emoji: "🤢",
        unicode: "u1f922",
    },
    "face_with_open_mouth_vomiting": {
        emoji: "🤮",
        unicode: "u1f92e",
    },
    "smiling_face_with_halo": {
        emoji: "😇",
        unicode: "u1f607",
    },
    "smiling_face_with_horns": {
        emoji: "😈",
        unicode: "u1f608",
    },
    "thinking_face": {
        emoji: "🤔",
        unicode: "u1f914",
    },
    "zany_face": {
        emoji: "🤪",
        unicode: "u1f61c",
    },
    "rolling_on_the_floor_laughing": {
        emoji: "🤣",
        unicode: "u1f923",
    },
    "star": {
        emoji: "⭐",
        unicode: "u2b50",
    },
    "thumbs_up": {
        emoji: "👍",
        unicode: "u1f44d",
    },
    "red_heart": {
        emoji: "❤",
        unicode: "u2764",
    },
} as const;

type EmojiName = keyof typeof EMOJI_DICTIONARY;

type EmojiRow = [EmojiName, EmojiName, EmojiName, EmojiName, EmojiName];
type EmojiMatrix = EmojiRow[]


export const EMOJI_MATRIX: EmojiMatrix = [
    [
        "grinning_face",
        "worried_face",
       "crying_face",
        "loudly_crying_face",
        "relieved_face",
    ],
    [ // 2行目
        "astonished_face",
        "winking_face",
        "face_blowing_a_kiss",
        "smiling_face_with_heart_eyes",
        "face_with_tears_of_joy",
    ],
    [ // 3行目
        "smiling_face_with_sunglasses",
        "dizzy_face",
        "angry_face",
        "pouting_face",
        "face_with_rolling_eyes",
    ],
    [ // 4行目
        "smiling_face_with_smiling_eyes",
        "face_with_stuck-out_tongue_and_tightly-closed_eyes",
        "face_with_head-bandage",
        "face_screaming_in_fear",
        "cold_face",
    ],
    [ // 5行目
        "nauseated_face",
        "face_with_open_mouth_vomiting",
        "smiling_face_with_halo",
        "smiling_face_with_horns",
        "thinking_face",
    ],
    [ // 6行目
        "zany_face",
        "rolling_on_the_floor_laughing",
        "star",
        "thumbs_up",
        "red_heart",
    ],
];

export const emojiSVGPath = (emojiName: EmojiName) => {
    const unicode = EMOJI_DICTIONARY[emojiName].unicode;
    return `${EMOJI_BASE_PATH}/emoji_${unicode}_${emojiName}.svg`;
}

export const flatten = <T>(nested: T[][]): T[] => 
    nested.reduce((acc, list) => acc.concat(list), []);

export const EMOJI_NAMES = flatten(EMOJI_MATRIX);

export const preloadEmojis = () => {
    Object.keys(EMOJI_DICTIONARY).forEach((emojiName: EmojiName) => {
        const img = document.createElement('img');
        img.src = emojiSVGPath(emojiName);
    })
}

export const convertEmojiToCode = (stringWithEmoji: string) => {
    return [...stringWithEmoji].map((char) => {
        const emojiName = Object.keys(EMOJI_DICTIONARY).find((name: EmojiName) => EMOJI_DICTIONARY[name].emoji === char);
        if (emojiName !== undefined) {
            return `:${emojiName}:`;
        }
        return char;
    }).join("");
}